export const visit = (vm, at) => {
at({ "no-no": { "conversationsVisitorUIAvailability": { "sameDay": "Vi kommer tilbake i dag kl. {{time}}", "nextDay": "Vi kommer tilbake i morgen kl. {{time}}", "nextWeek": "Vi kommer tilbake {{dayOfWeek}} kl. {{time}}" } } });
};